export const appendObjectToSearchParams = (url: URL, params: Object) => {
  Object.entries(params)
    .filter(([_, value]) => value !== undefined)
    .forEach(([key, value]) => url.searchParams.set(key, value.toString()));
};
